/**
 * Like Text_Wiki_Render_Xhtml_Grid, only a positive count fixes a grid's
 * columns; anything else (null, 0, garbage) is the automatic layout. Docs
 * rendered before the Json renderer sent null for that still carry 0.
 */
export function fixedGridColumns(columns: unknown): number | null {
   const count = Number.parseInt(String(columns), 10);
   return count > 0 ? count : null;
}
